import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit,faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';

const ListExceptionsActions = ({ data,updateExceptions,refresh }) => {

    const deleteException = async () => 
    {
        let dataException = {
            id_excepcion: data.data.original.id_excepcion
        };
        let url = `honorarios/eliminar-excepcion`;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'DELETE',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataException)
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                refresh();
            }
            else
            {
                throw new Error('Error en Eliminar el Honorario');
            }
        }).catch(err => {
            alert("Ha ocurrido un error eliminando la Excepcion");
        });
    }

    useEffect(() => {
        
    }, []);

    return (<Fragment>
        <td role="cell">
        <Tooltip title="Editar Excepcion">
                <IconButton style={{ fontSize: '15px' }} onClick={() => updateExceptions(data.data.original)}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar Excepcion">
                <IconButton style={{ fontSize: '15px' }} onClick={() => deleteException()}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
        </td>
    </Fragment>)
}

export default ListExceptionsActions;